/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
var LightTorsoe = function (quality) {
  return {
    slot: 'torsoe',
    type: 'light',
    quality: quality,
    armorClass: Math.round(6 + quality * 42),
    willpower: Math.round(3 + quality * 6),
  };
};
module.exports = LightTorsoe;
